<template>
  <div class="account-appeal-index">
    <h3>账号申诉</h3>
    <p>请选择您要办理的业务</p>

    <div class="index-select" style="margin-top: 30%;" @click="junpWindow(`/accountAppeal/secondphone`)">
      <img src="../../assets/img/shensu/phone2x.png" alt="">
      <span>手机号被占用</span>
    </div>

    <div class="index-select" @click="idcardHandler(`/accountAppeal/secondIdcard`)">
      <img src="../../assets/img/shensu/idcard2x.png" alt="">
      <span>身份证号被占用</span>
    </div>
  </div>
</template>

<script>
export default {
  data(){
      return {

      }
  },
  created(){

  },
  methods: {
    junpWindow(path){
      this.$router.push({path})
    },
    idcardHandler(path){
      this.$router.push({path})
    }
  }
}
</script>

<style scoped>
  .account-appeal-index{
    height: 100%;
    background-color: #FFFFFF;
    padding: 20px 20px 0px 20px;
    box-sizing: border-box;
  }
  .account-appeal-index h3{
    font-size: 0.7rem;
    color: #287BAC;
    margin-bottom: 5px;
    font-weight: 400;
  }
  .account-appeal-index p{
    font-size: 0.35rem;
    color: #999999;
    letter-spacing: 1.5px;
    margin-top: 10px;
  }
  .index-select{
    width: 100%;
    padding: 0px 15px;
    box-sizing: border-box;
    text-align: center;
    margin-top: 40px;
    border-radius: 3px;
    border: 1.3px solid #0F8EE8;
  }
  .index-select span{
    font-size: 0.44rem;
    color: #0F8EE8;
    height: 55px;
    line-height: 55px;
  }
  .index-select img{
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 5px;
    margin-top: 5px;
  }
</style>
